/**
 * Хранилище JWT для admin-app.
 *
 * admin-app живёт на отдельном поддомене (admin.lovarthotels.com) и работает
 * с сессией оператора платформы (platform_admin). Используем собственный ключ
 * localStorage, чтобы не конфликтовать с сессиями manager-web / guest-portal
 * на других поддоменах.
 */

export const ACCESS_TOKEN_KEY = 'hsc_admin_access_token';
export const REFRESH_TOKEN_KEY = 'hsc_admin_refresh_token';

/** Прочитать JWT из localStorage. */
export function readAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
}

/** Записать access-token в localStorage. */
export function writeAccessToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
  } catch {
    // игнорируем ошибки хранилища (приватный режим, квота)
  }
}

/** Записать refresh-token в localStorage. */
export function writeRefreshToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    // игнорируем
  }
}

/** Очистить токены (выход / истечение сессии). */
export function clearTokens(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
    window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // игнорируем
  }
}
